import Sidebar from "@/components/Sidebar";

export function ThingsToDo() {
  document.title = "Things to Do | Katelynn & Thomas";
  return (
    <div className="p-4 h-full w-full flex flex-row justify-center items-center max-w-7xl mx-auto">
      <div className="h-full w-full grid grid-cols-1 md:grid-cols-5 gap-4">
        <Sidebar />
        <div className="bg-light dark:bg-dark rounded-2xl drop-shadow-2xl col-span-1 md:col-span-4 p-6 flex flex-col gap-4 post overflow-y-auto overflow-x-hidden">
          <div className="flex flex-col gap-2">
            <h2 className="text-3xl font-script font-bold">
              What to Do While in Anchorage
            </h2>
            <p className="text-lg">
              Anchorage in March is the tail end of winter, when the
              temperatures are closer to East Coast winter (20s and 30s).
              Barring freak weather incidents, there should be feet of snow on
              the ground and frozen lakes thick enough for skating. While likely
              not the time for steep mountain hikes or swimming, there are
              plenty of awesome things to do! We'll provide some suggestions
              here, but there are many more to discover.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-2xl font-script font-bold">
              Our Favorite Local Spots
            </h3>
            <p className="text-lg">
              Looking for some nearby spots for a scenic walk or an
              easy-to-access view? We've got you covered.
            </p>

            <h4 className="text-xl font-script font-bold">Kincaid Park</h4>
            <p className="text-lg italic">~5 mins from downtown Anchorage</p>
            <div className="flex flex-row gap-4">
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/kincaid1.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/kincaid2.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/kincaid3.jpg?size=1024&quality=60"
                />
              </div>
            </div>
            <p className="text-lg">
              Kincaid Park is a large partly-wooded park with groomed trails,
              great views of the inlet, and the "stadium" area below the ski
              chalet where races take place. Keep your eyes peeled on your
              descent into/takeoff from Anchorage--the park surrounds the
              western top of the airport's east-west runway.
            </p>

            <h4 className="text-xl font-script font-bold">
              Westchester Lagoon
            </h4>
            <p className="text-lg italic">~5 mins from downtown Anchorage</p>
            <div className="flex flex-row gap-4">
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/westchester1.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/westchester2.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/westchester3.jpg?size=1024&quality=60"
                />
              </div>
            </div>
            <p className="text-lg">
              Westchester Lagoon is a beautiful spot between downtown and
              midtown. It is a very popular location for ice skating throughout
              the winter, and it is regularly plowed and hot-mopped. On a clear
              day you can enjoy beautiful views of the Chugach mountains while
              skating around the lagoon's islands. Multiuse trails for walking,
              cross-country skiing, and biking wrap around the lagoon and
              connect to the Chester Creek and Costal Trail systems.
            </p>

            <h4 className="text-xl font-script font-bold">Potter Marsh</h4>
            <p className="text-lg italic">~10 mins from downtown Anchorage</p>
            <div className="flex flex-row gap-4">
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/marsh1.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/marsh2.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/marsh3.jpg?size=1024&quality=60"
                />
              </div>
            </div>
            <p className="text-lg">
              Potter Marsh is a small area at the southern tip of Anchorage
              proper. It is wrapped on its northeast corner by a well-maintained
              boardwalk for spotting wildlife--we frequently see moose here in
              all seasons, so a great spot to try and catch a glimpse!
            </p>

            <h4 className="text-xl font-script font-bold">Glen Alps</h4>
            <p className="text-lg italic">~15 mins from downtown Anchorage</p>
            <div className="flex flex-row gap-4">
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/glenalps1.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/glenalps2.jpg?size=1024&quality=60"
                />
              </div>
            </div>
            <p className="text-lg">
              Glen Alps is a lovely hilltop park near the start of the trail up
              Flattop Mountain. Beautiful in all seasons, it provides views of
              both the Chugach Mountains to the east and the city and Cook Inlet
              to the west. If it's an especially clear day, you may even catch a
              glimpse of Denali's peak (the tallest in North America!). We got
              engaged here (also in March)!
            </p>

            <h4 className="text-xl font-script font-bold">Beluga Point</h4>
            <p className="text-lg italic">~20 mins from downtown Anchorage</p>
            <div className="flex flex-row gap-4">
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/belugapoint1.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/belugapoint2.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/belugapoint3.jpg?size=1024&quality=60"
                />
              </div>
            </div>
            <p className="text-lg">
              Beluga Point is a turnout along the highway a few minutes south of
              Anchorage proper. While the turnout has some great views from the
              road itself, you can get additional views by scrambling across the
              Alaska Railroad tracks to the large, traversible bluff sticking
              out into the inlet. Try and catch a sunset!
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-2xl font-script font-bold">Short Car Trips</h3>
            <p className="text-lg">
              Venturing out of town? Lots to see both north and south of
              Anchorage.
            </p>

            <h4 className="text-xl font-script font-bold">Girdwood</h4>
            <p className="text-lg italic">~45 mins from downtown Anchorage</p>
            <div className="flex flex-row gap-4">
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/girdwood1.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/girdwood2.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/girdwood3.jpg?size=1024&quality=60"
                />
              </div>
            </div>
            <p className="text-lg">
              Girdwood is a lovely ski town about 45 minutes south of the city.
              Our wedding venue, Alyeska Resort, is located here--it is an IKON
              pass ski resort and hotel, for which you can use our discount code
              to book a room. In town, you can find an awesome brewery, groomed
              (packed down for skiing) trails, and the Alyeska Aerial Tram,
              which you can take to the top of the mountain for incredible
              views.
            </p>

            <h4 className="text-xl font-script font-bold">
              Alaska Wildlife Conservation Center
            </h4>
            <p className="text-lg italic">~1 hour from downtown Anchorage</p>
            <div className="flex flex-row gap-4">
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/awcc1.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/awcc2.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/awcc3.jpg?size=1024&quality=60"
                />
              </div>
            </div>
            <p className="text-lg">
              The Alaska Wildlife Conservation Center, featured in the Disney+
              show "Alaska Animal Rescue," is another ~15 minutes past Girdwood,
              and is well worth a visit. The AWCC is home to an impressive
              collection of native animals for care and rehabilitation--a great
              chance to see moose, bears, musk ox, and more up close. You can
              even drive between animal habitats for more time spent in a warm
              car rather than in the chilly March air.
            </p>

            <h4 className="text-xl font-script font-bold">Eklutna Lake</h4>
            <p className="text-lg italic">~1 hour from downtown Anchorage</p>
            <div className="flex flex-row gap-4">
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/eklutna1.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/eklutna2.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/eklutna3.jpg?size=1024&quality=60"
                />
              </div>
            </div>
            <p className="text-lg">
              Eklutna Lake is most fun in the summer because of the
              hiking/biking/ATV trails nearby, but it's a spectacle regardless.
              There are also reservable dry cabins available on property, which
              we have stayed in the middle of winter before. They are
              well-insulated and on the cheaper end, but remember to bring
              firewood for the stove to heat them!
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="text-2xl font-script font-bold">
              Longer Adventures
            </h3>
            <p className="text-lg">
              Alaska is huge--if you're willing to drive a bit further, there is
              much to see.
            </p>
            <p className="text-lg">
              NOTE: the northernly destinations may be accessible by train
              during your visit! Check out their{" "}
              <a href="https://www.alaskarailroad.com/">site</a> for details.
            </p>

            <h4 className="text-xl font-script font-bold">Whittier</h4>
            <p className="text-lg italic">~1.25 hours from Anchorage</p>
            <div className="flex flex-row gap-4">
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/whittier1.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/whittier2.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/whittier3.jpg?size=1024&quality=60"
                />
              </div>
            </div>
            <p className="text-lg">
              Whittier is a tiny town famous for its residents all living in one
              giant Soviet bloc style building. Nowadays, it has a lovely inn
              and a set of cute shops, but we mostly recommend it for the trip
              and the views. Along the road to Whittier, you pass by Beluga
              Point and the AWCC, then drive along the beautiful Portage Lake.
              We've XC skiied across the lake (in March actually) to see the
              glacier up closer, but probably not a trip for beginners. After
              Portage, you traverse the longest tunnel in North America, and
              exit the tunnel to be greeted by the open mouth of the bay. Not a
              ton to do once there in the winter, but in the summer the influx
              of cruises stopping in Whittier create some attractions for
              tourists (but probably not by March).
            </p>

            <h4 className="text-xl font-script font-bold">
              Hatcher Pass (Independence Mine)
            </h4>
            <p className="text-lg italic">~1.25 hours from Anchorage</p>
            <div className="flex flex-row gap-4">
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/hatcher1.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/hatcher2.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/hatcher3.jpg?size=1024&quality=60"
                />
              </div>
            </div>
            <p className="text-lg">
              Hatcher Pass (Independence Mine State Park) was once the site of a
              moderately sized mining operation, and many of the historic
              buildings are still around to see. The area is a lot easier to
              traverse in the summer, but we like Hatcher Pass for XC skiing on
              Archangel Road and taking in the incredible snowy mountains. In
              the summer, you can actually traverse the pass to get to Willow,
              but this part of the road is closed in March. The park is also
              home to Hatcher Pass Lodge, a cute group of rentable cabins with
              the largest being a restaurant, and to the Skeetawk downhill ski
              area. We have also seen snowmobile races up here! Your trip will
              take you through Palmer (we recommend Vagabond Blues for some
              coffee and Thomas recommends the Bleeding Heart Brewery for super
              interesting beer).
            </p>

            <h4 className="text-xl font-script font-bold">
              Start of the Iditarod (Willow)
            </h4>
            <p className="text-lg italic">~1.5 hours from Anchorage</p>
            <div className="flex flex-row gap-4">
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/willow1.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/willow2.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/willow3.jpg?size=1024&quality=60"
                />
              </div>
            </div>
            <p className="text-lg">
              The Iditarod is the most famous dogsled race in the world, and
              happens to be starting the same weekend as our wedding! The
              afternoon of the 7th, the mushers will take off with their dogs
              from Willow Lake at the start of their 1,100 mile journey to Nome.
              The ceremonial start will be in Anchorage on the 6th (likely just
              prior to or overlapping with our own ceremony), but the official
              start will be in Willow the following day. Your trip will take you
              past the turnoff for Palmer and Hatcher Pass. You can also catch
              the Iditarod Headquarters (the organization's base of operations
              and a log cabin museum) with a short stop in Wasilla.
            </p>

            <h4 className="text-xl font-script font-bold">Talkeetna</h4>
            <p className="text-lg italic">~2 hours from Anchorage</p>
            <div className="flex flex-row gap-4">
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/talkeetna1.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/talkeetna2.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/talkeetna3.jpg?size=1024&quality=60"
                />
              </div>
            </div>
            <p className="text-lg">
              Talkeetna is a tiny but cute town close to Denali. On the drive
              up, keep your eyes peeled for unbelievable views of Denali and its
              surrounding peaks, glacial flow from two different mountain
              ranges, and Denali Brewing Company, right near the turnoff up to
              Talkeetna. While in town, check out the Fairview Inn and the
              variety of little antique shops for some rustic charm, or the
              ranger station for some Denali history. We recommend Conscious
              Coffee for some caffeine refueling and Denali Brewpub (same
              company as the brewery) for a good meal and a pint. Although not
              particularly allergy-friendly, the Flying Squirrel Bakery and Cafe
              is also a worthwhile visit. Your trip up will take you past the
              turnoff for Palmer and Hatcher Pass, through Willow, and past many
              turnouts to stop for incredible pictures. Also check out Denali
              State Park while you're in the area--there are many turnouts with
              better views of the peak.
            </p>

            <h4 className="text-xl font-script font-bold">Seward</h4>
            <p className="text-lg italic">~2.5 hours from Anchorage</p>
            <div className="flex flex-row gap-4">
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/seward1.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/seward2.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/seward3.jpg?size=1024&quality=60"
                />
              </div>
            </div>
            <p className="text-lg">
              Seward is one of our favorite places in the state. Seward is home
              to many small businesses, little restaurants, beach areas, boat
              docks, and the Alaska SeaLife Center. Katelynn interned at the
              ASLC and we can thoroughly recommend taking a spin through. They
              are one of very few aquariums focused on rescue and rehabilitation
              as well as research, so you have the opportunity to see rare and
              endangered animals along with many other animals not commonly
              available for public viewing. Check their schedule before visiting
              as the aquarium's winter hours are more limited. We recommend
              stopping in Resurrect Art, a coffee shop based out of an old
              church and filled with local art, while in town. Your trip will
              take you past Beluga Point, the AWCC, the turnoff for Whittier,
              the turnoff for Soldotna and Whittier, and enough mountains you
              will be sick of them by the time you arrive. Seward is also a
              great chance to knock off a National Park--Kenai Fjords butts up
              against the town, and jutting off from Seward is the only paved
              road into the park whatsoever (most other access is by boat).
            </p>

            <h4 className="text-xl font-script font-bold">
              Denali National Park
            </h4>
            <p className="text-lg italic">~4 hours from Anchorage</p>
            <div className="flex flex-row gap-4">
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/denali1.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/denali2.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/denali3.jpg?size=1024&quality=60"
                />
              </div>
            </div>
            <p className="text-lg">
              Feeling bold? Or just want to knock another National Park off the
              list? While Denali State Park is not far from Talkeetna, reaching
              the entrance to Denali National Park requires a significantly
              further trek. If you have the time and the will, it's an
              incredible journey. It's hard to know until closer how much of the
              road will be open, but we've been down mid winter and there is
              still plenty to see. Like what you see? Come back when it's warm
              out and explore more of the vast landscape.
            </p>
            <h4 className="text-xl font-script font-bold">Fairbanks</h4>
            <p className="text-lg italic">~6.5 hours from Anchorage</p>
            <div className="flex flex-row gap-4">
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/fairbanks1.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/fairbanks2.jpg?size=1024&quality=60"
                />
              </div>
              <div className="h-50">
                <img
                  className="w-full h-full object-cover"
                  width={1024}
                  height={1024}
                  src="/public/fairbanks3.jpg?size=1024&quality=60"
                />
              </div>
            </div>
            <p className="text-lg">
              Fairbanks is the third largest city in the state. It is much
              farther north than Anchorage and in Interior Alaska, so it
              experiences larger seasonal daylight and temperature swings.
              Winter temperatures are frequently well below 0°F, so make sure
              you bring appropriate winter gear. The Fairbanks area is also
              great for northern lights viewing opportunities. The annual World
              Ice Art Championships will be happening in town, and is a must if
              you're in the area. If you drive further out of town, Chena Hot
              Springs Resort is also an interesting place to visit.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThingsToDo;
